.cn{justify-content:flex-end;}